<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Аналитика</h4>
            <div class="sub-title">Умный анализ отзывов и выявление трендов</div>
          </div>
        </div>

        <TopBlock></TopBlock>
      </div>

    </div>

<!--        <AnalyticData></AnalyticData>-->

    <div class="card p-3 filter">
<!--      <div class="card-header">-->
<!--      <div class="bolder-title title">-->
<!--        <div class="wrap">-->
<!--          Ответы-->
<!--        <popper hover-->
<!--                content="Количество ответов для каждого домена + показано какой это процент от общего количество отзывов для этого домена">-->
<!--          <i class="bi bi-info pointer"></i>-->
<!--        </popper>-->


<!--      </div>-->
<!--        <div class="buttons ms-auto">-->
<!--          <button v-if="tag_count !== selected.length" class="btn btn-primary btn-sm" @click="setAllSelected">Выбрать-->
<!--            всё-->
<!--          </button>-->
<!--          <button v-else class="btn btn-primary btn-sm" @click="selected = []">Отключить всё</button>-->
<!--        </div>-->


<!--      </div>-->
<!--        <div class="sub-title">Выберите категории и темы для анализа</div>-->
<!--    </div>-->

      <div class="title">
        <div class="wrap">
          <h5>Фильтрация по тегам

            <popper hover content="График распределения категорий и тэгов по тональности">
              <i class="bi bi-info pointer text-dark"></i>
            </popper>
          </h5>
          <div class="sub-title">Выберите категории и темы для анализа</div>
        </div>
        <div class="buttons ms-auto">
          <button v-if="tag_count !== selected.length" class="btn btn-primary btn-sm" @click="setAllSelected">Выбрать
            всё
          </button>
          <button v-else class="btn btn-primary btn-sm" @click="selected = []">Отключить всё</button>
        </div>
      </div>
      <div class="categories" v-for="category in categories">
        <b>{{ category.name }}:</b>
        <!--          <div class="tags">-->
        <!--          <div v-for="color in $TAGS" :class="'tag active'"-->
        <!--               :style="{backgroundColor: color + '20', color: color, borderColor: color}">-->
        <!--            <i class="bi bi-check"></i> Тэг-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="tags">
          <div v-for="tag in category.tags" :class="'tag'+(selected.indexOf(tag.id)+1?' active':'')"
               @click="addTag(tag.id)"
               :style="{backgroundColor: tag.color + '20', color: tag.color, borderColor: tag.color}">
            <i class="bi bi-check"></i> {{ tag.name }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <span>Выбрано: <b>{{ selected.length }} из {{
            categories.map(x => x.tags).flat().map(x => x.id).length
          }} тегов</b></span>
        <a href="" class="ms-auto text-primary" @click.prevent="getData"><b>Применить фильры <i
            class="bi bi-arrow-right"></i></b></a>
      </div>

    </div>
    <div class="charts">


      <div class="card" v-for="chart in charts">
        <h5 class="card-header">{{ chart.name }}</h5>
        <Bar :aria-describedby="chart.name"
             :options="chartOptions()"
             :data="datacollection(chart)"
             style="height: 350px"
        />

      </div>
    </div>
    <div class="card p-3 mt-3">
      <div class="title">
        <div class="wrap" style="width: 100%">
          <h5>Динамика тональности по категориям
            <popper hover>
              <i class="bi bi-info pointer text-dark"></i>
              <template #content>
                <strong>Упоминание категорий по дням с тональностью</strong>
                <div class="sub-title">Каждый бар показывает категорию, цвет внтури - тональность отзывов</div>
              </template>
            </popper>

          </h5>
          <div class="title">

            <div class="buttons ms-auto">
              <div class="btn-group" role="group">
                <template v-for="(name, value) in states">
                  <input type="radio" class="btn-check" name="btnradio" :id="value" autocomplete="off"
                         :checked="state===value" @change="state=value">
                  <label class="btn btn-outline-primary" :for="value">{{ name }}</label>
                </template>

              </div>
            </div>
          </div>
        </div>
        <div class="buttons ms-auto">
        </div>
      </div>
      <div class="line tonality">
        Показать тональность:
        <span v-for="tone in resources" :class="'tone'+(tone.check_bar?' active':'')"
              @click="tone.check_bar=!tone.check_bar">
          <span class="point" :style="{backgroundColor: tone.bcolor}"></span>
          <span>{{ tone.name }}</span>
        </span>
      </div>
      <div class="card border-0" style="max-height: 500px">
        <Bar
            :options="chartOptions()"
            :data="datacollectionTag(tag_chart)"
        />
      </div>

    </div>

  </div>


</template>

<script>


import TopBlock from "@/components/TopBlock.vue";
import {ProjectApi} from "@/api/projects";
import {ReviewApi} from "@/api/reviews";
import {Bar} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import AnalyticData from "@/views/dictionary/review/components/AnalyticData.vue";
import datesMixin from "@/mixins/filterDates";
import {handleChartClick} from "@/plugins/chartPlugin";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


export default {
  name: 'ProjectAnalytic',
  mixins: [datesMixin],
  data() {
    return {
      categories: [],
      selected: [],
      tag_count: 0,
      charts: null,
      tag_chart: null,
      state: "week",
      states: {"day": "По дням", "week": "По неделям"},
      resources: [
        {
          id: 1,
          name: "Негативные",
          filter: "negative",
          param: "negatives",
          check: true,
          check_bar: true,
          bcolor: "#FF3B30",
          color: "#FF3B3033"
        },
        {
          id: 2,
          check: true,
          check_bar: true,
          filter: "positive",
          param: "positives",
          name: "Позитивные",
          color: "#59DDAA33",
          bcolor: "#59DDAA"
        }
      ],
    }
  },
  components: {Bar, TopBlock, AnalyticData},
  watch: {
    dates() {
      this.getData();
    },
    state() {
      this.getTagStat()
    }
  },

  computed: {

    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },
  mounted: function () {
    const $this = this;
    ProjectApi.reviews_tags(this.$store.getters.currentProjectId, 1, 200).then(response => {
      $this.categories = response;
      $this.categories.forEach(cat => {
        $this.tag_count += cat.tags.length
      })
      $this.setAllSelected()
      this.getData()

    })

  },
  methods: {
    setAllSelected() {
      this.selected = [];
      this.categories.forEach(cat => {
        this.selected = this.selected.concat(cat.tags.map(x => x.id))
      })
    },
    datacollection(base_data) {
      let data = {
        labels: base_data.tags,
        datasets: []
      }
      this.resources.filter(x => x.check === true).forEach(resource => {
        console.log(base_data)
        data.datasets.push({
          label: resource.name,
          label_id: resource.id,
          borderColor: resource.bcolor,
          borderWidth: 2,
          borderRadius: 5,
          backgroundColor: resource.color,
          data: base_data[resource.param]
        })
      })
      return data;
    },
    datacollectionTag(base_data) {
      let data = {
        labels: base_data?.dates,
        datasets: []
      }
      if (!base_data?.series) return data;

      const tagsByName = {};

      base_data.series.forEach(tag => {
        if (this.resources.find(x => x.filter === tag.type).check_bar) {
          if (!tagsByName[tag.name]) {
            tagsByName[tag.name] = {
              name: tag.name,
              positive: null,
              negative: null,
              total: 0
            };
          }

          if (tag.type === 'positive') {
            tagsByName[tag.name].positive = tag;
          } else if (tag.type === 'negative') {
            tagsByName[tag.name].negative = tag;
          }

          const tagSum = tag.data.reduce((acc, val) => acc + (val || 0), 0);
          tagsByName[tag.name].total += tagSum;
        }
      });

      const sortedTagNames = Object.values(tagsByName)
          .sort((a, b) => b.total - a.total)
          .map(t => t.name);

      const datasets = [];

      sortedTagNames.forEach(tagName => {
        const tags = base_data.series.filter(tag =>
            tag.name === tagName &&
            this.resources.find(x => x.filter === tag.type).check_bar
        );

        const positiveTag = tags.find(t => t.type === 'positive');
        const negativeTag = tags.find(t => t.type === 'negative');

        if (positiveTag) {
          datasets.push({
            label: positiveTag.name + ' (Позитив)',
            borderColor: positiveTag.color + "99",
            borderWidth: 2,
            backgroundColor: positiveTag.color + "99",
            data: positiveTag.data,
            stack: positiveTag.name,
            hidden: sortedTagNames.indexOf(tagName) >= 5
          });
        }

        if (negativeTag) {
          datasets.push({
            label: negativeTag.name + ' (Негатив)',
            borderColor: negativeTag.color,
            borderWidth: 2,
            backgroundColor: negativeTag.color,
            data: negativeTag.data,
            stack: negativeTag.name,
            hidden: sortedTagNames.indexOf(tagName) >= 5
          });
        }
      });

      data.datasets = datasets;
      return data;
    },
    chartOptions(title) {
      return {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        onHover: (event, chartElement) => {
          event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
        },
        onClick: handleChartClick(this.$router, (dataIndex, clickedLabel, labelId) => {

          // const tone = this.$TONES.find(t => t.name === dataIndex);
          // return tone ? {tones: tone.id, tags: String(labelId)} : null;
        }),
        scales: {
          x:
              {
                stacked: true,
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: false,
                  // maxTicksLimit: 10,
                  maxRotation: 45,
                  autoSkipPadding: 15
                },
              },
          y:
              {
                stacked: true,

                ticks: {
                  stepSize: 1
                },

                grid: {
                  display: false
                },
                suggestedMin: 30,
              },

        },
        interaction: {
          mode: 'index',
          intersect: false,
        },

        plugins: {
          title: {
            display: true,
            text: title,
          },
          htmlLegend: {
            containerID: 'legend-container',
          },
          legend: {
            display: true,
          },
          datalabels: {
            formatter: function (value, context) {
              return '';
            }
          }
        }
      }
    },
    getData() {
      if (this.selected.length) {
        ReviewApi.get_tag_statistics(this.date_from, this.date_to, this.selected).then(response => this.charts = response)
        this.getTagStat()
      } else this.$notify({
        type: 'error',
        title: 'Ошибка',
        text: 'Выберите хотя бы один тег'
      });


    },
    getTagStat() {
      ReviewApi.daily_tag_statistics(this.state, this.date_from, this.date_to, this.selected).then(response => this.tag_chart = response)
    },
    addTag(tag_id) {
      const index = this.selected.findIndex(x => x === tag_id);
      if (index >= 0) this.selected.splice(index, 1)
      else this.selected.push(tag_id)
    }
  }
}

</script>
<style scoped lang="scss">
.charts {
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 50px;
  display: flex;

  .card {
    width: 40vw;
    height: 400px;
    padding-bottom: 50px;
  }
}

.filter {

  .bottom {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 15px;
  }

  .tags {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    margin-bottom: 10px;
    margin-top: 5px;

    .tag {
      border: 1px solid var(--grey);
      border-radius: 5px;
      padding: 2px 5px;
      font-weight: bold;
      cursor: pointer;

      &:not(.active) {
        border-color: var(--grey) !important;
        color: var(--grey) !important;
        background-color: var(--grey)+'20' !important;
      }
    }
  }
}

.tonality {
  display: flex;
  gap: 10px;
  align-items: center;

  .tone {
    cursor: pointer;
    padding: 0 5px;
    display: flex;
    gap: 5px;
    align-items: center;

    &.active {
      border: 1px solid var(--grey);
      border-radius: 5px;
    }
  }

  .point {
    height: 15px;
    width: 15px;
    display: inline-block;
    border-radius: 15px;
  }
}


@media (width < 768px) {
  .charts {
    .card {
      width: 100%;
    }
  }
}

</style>
